import React, { useState, useEffect } from 'react';
import PageTitle from '../../Components/utils/PageTitle';
import DataTableTemplate from '../../Components/Tables/DataTableTemplate';
import { getPatientIdList, getMessageHistory } from '../../api/MessageHistory/msgHistory';
import { AuthContext } from '../../Context/AuthProvider';
import { useContext } from 'react';
const getUserInfo = () => {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    return user ? user : null;
}
const MessageHistory = () => {
  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  }
  const { user } = useContext(AuthContext) || null;
  const {role, country} = user;
    const [Phase, setPhase] = useState("p4");
    const [Country, setCountry] = useState(country);
    const [patientIdList, setPatientIdList] = useState([]);
    const [filteredPatients, setFilteredPatients] = useState([]);
    const [patientId, setPatientId] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const [filteredData, setFilteredData] = useState([]);

    const columns = [
        { name: "Patient ID", selector: (row) => row.PatientID, sortable: true },
        // { name: "Site ID", selector: (row) => row.SiteID, sortable: true },
        { name: "Country", selector: (row) => row.Country, sortable: true },
        { name: "Phase", selector: (row) => row.Phase, sortable: true },
        { name: "Day Index", selector: (row) => row.DayIndex, sortable: true },
        { name: "Msg Index", selector: (row) => row.MessageIndex, sortable: true },
        // { name: "Status", selector: (row) => row.Status, sortable: true },
        { 
          name: "Status", 
          selector: (row) => row.Status, 
          sortable: true,
          cell: (row) => (
              <span 
                  className={`px-2 py-1 rounded-full text-white text-xs font-semibold ${
                      row.Status.toLowerCase() === 'success' 
                          ? 'bg-green-500' 
                          : 'bg-red-500'
                  }`}
              >
                  {row.Status}
              </span>
          ) 
      },
        { name: "Sent Time", selector: (row) => formatDate(row.SentTime), sortable: true, width: '200px' },
    ];

    const getPatientIdListData = async () => {
        try {
            const response = await getPatientIdList(Country, Phase);
            setPatientIdList(response);
            setFilteredPatients(response); // Set initially to all patients
        } catch (error) {
            setPatientIdList([]);
            console.error(error);
        }
    };

    const getMessageHistoryData = async (selectedId) => {
        try {
            const response = await getMessageHistory(selectedId);
            setFilteredData(response);
        } catch (error) {
            setFilteredData([]);
            console.error(error);
        }
    };

    useEffect(() => {
        if (Country && Phase) {
            getPatientIdListData();
        }
    }, [Country, Phase]);

    useEffect(() => {
        if (patientId) {
            getMessageHistoryData(patientId);
        }
    }, [patientId]);

    // Handle search input change
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        if (value) {
            setFilteredPatients(patientIdList.filter(id => id.toLowerCase().includes(value.toLowerCase())));
        } else {
            setFilteredPatients(patientIdList);
        }
        setShowDropdown(true);
    };

    return (
        <>
            <PageTitle title="Message History" />

            <div className="w-full mx-0 bg-white h-screen">
                <div className="container mx-auto object-cover border-red-700">
                    <div className="flex p-3 pl-0 flex-col flex-wrap justify-center md:justify-start md:flex-row gap-4">
                       {
                            role === "SUPER_ADMIN" || role === "ADMIN" ? (
                        <div className='w-32'>
                            <select
                                id="Country"
                                name="Country"
                                onChange={(e) => setCountry(e.target.value)}
                                defaultValue={Phase}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            >
                                <option value="">Country *</option>
                                <option value="All">All</option>
                                <option value="Pakistan">Pakistan</option>
                                <option value="Bangladesh">Bangladesh</option>
                            </select>
                        </div>
                            ): null
                       }
                        <div className='w-24'>
                            <select
                                id="phase"
                                name="phase"
                                onChange={(e) => setPhase(e.target.value)}
                                defaultValue={Phase}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            >
                                <option value="" disabled selected>Phase *</option>
                                {Country && (
                                    <>
                                        <option value="p3">Phase 3</option>
                                        <option value="p4">Phase 4</option>
                                    </>
                                )}
                            </select>
                        </div>

                        {/* Searchable Patient ID Dropdown */}
                        <div className="relative w-64">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                onFocus={() => setShowDropdown(true)}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                placeholder="Search Patient ID..."
                            />
                            {showDropdown && filteredPatients.length > 0 && (
                                <ul className="absolute z-10 bg-white border border-gray-300 rounded-lg w-full max-h-40 overflow-y-auto mt-1 shadow-lg">
                                    {filteredPatients.map((TBRegistrationNumber) => (
                                        <li
                                            key={TBRegistrationNumber}
                                            onClick={() => {
                                                setPatientId(TBRegistrationNumber);
                                                setSearchTerm(TBRegistrationNumber);
                                                setShowDropdown(false);
                                            }}
                                            className="p-2 hover:bg-blue-500 hover:text-white cursor-pointer"
                                        >
                                            {TBRegistrationNumber}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>

                {/* Data Table */}
                <div className="">
                    <div className="overflow-auto">
                        <DataTableTemplate columns={columns} data={filteredData} isselectableRows= {false} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default MessageHistory;
